import React from 'react';
import styled from 'styled-components';

import ButtonContainer from './ButtonContainer';
import { lightGrey3Color } from 'js/config/style';

import Ellipsis from 'js/components/core/Icons/Ellipsis';
import ManageMenu from './ManageMenu';

const Icon = styled(Ellipsis).attrs({ color: lightGrey3Color })`
  height: 1rem;
  justify-self: center;
  align-self: center;
  width: 1rem;
`;

const Button = styled(ButtonContainer)`
  text-align: center;
`;

const Container = styled.div`
  position: relative;
  grid-area: ${({ area }) => area};
`;

export default props => (
  <Container area="manage" {...props}>
    <Button>
      <Icon />
    </Button>
    <ManageMenu />
  </Container>
);
